import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CheckboxTree from 'components/consumer/CheckboxTree';
import { find, filter, forEach, map } from 'lodash';

const mapSelectedIssue = selection => {
  const checkedCategories = filter(selection, { checked: true });
  const issues = [];
  forEach(checkedCategories, category => {
    const checkedIssues = filter(category.items, { checked: true });

    if (Array.isArray(checkedIssues) && checkedIssues.length > 0) {
      forEach(checkedIssues, issue => {
        const checkedComponent = filter(issue.items, { checked: true });
        const components =
          Array.isArray(checkedComponent) && checkedComponent.length > 0
            ? map(checkedComponent, 'value')
            : [];
        issues.push({
          category_id: category.value.toString(),
          issue_id: issue.value.toString(),
          components,
        });
      });
    } else {
      issues.push({
        category_id: category.value.toString(),
        issue_id: '',
        components: [],
      });
    }
  });
  return issues;
};

const IssuesCheckboxTree = ({ state, actions }) => {
  const { orderCartIssues, orderItem } = state;
  const [cartIssueList] = useState(() =>
    find(orderCartIssues, { cartId: orderItem.cart_id })
  );

  const buildIssueTree = categories => {
    const items = [];
    forEach(categories, category => {
      const categoryType = {
        label: category.title,
        value: category.id,
        checked: false,
        items: [],
      };
      if (category.issues) {
        forEach(category.issues, issue => {
          const issueType = {
            label: issue.title,
            value: issue.id,
            checked: false,
            items: [],
          };

          if (issue.components) {
            forEach(issue.components, component => {
              issueType.items.push({
                label: component.title,
                checked: false,
                value: component.id,
                items: [],
              });
            });
          }
          categoryType.items.push(issueType);
        });
      }
      items.push(categoryType);
    });
    return items;
  };
  const [items, setItems] = useState(() => {
    if (cartIssueList && cartIssueList.categories) {
      const issueTree = buildIssueTree(cartIssueList.categories);
      return Array.isArray(issueTree) && issueTree.length > 0 ? issueTree : [];
    }
    return [];
  });
  return (
    <CheckboxTree
      items={items}
      onChange={update => {
        setItems(update);

        actions.updateIssueDetails(orderItem.cart_id, {
          issues: mapSelectedIssue(update),
        });
      }}
    />
  );
};

IssuesCheckboxTree.propTypes = {
  state: PropTypes.object,
  actions: PropTypes.shape({ updateIssueDetails: PropTypes.func }),
};

export default IssuesCheckboxTree;
